import ActionSnippet from './ActionSnippet';

export default ActionSnippet;
export { ActionSnippet };
